import { Builder } from '@builder.io/react'
import React from 'react'

import { HeadingClass, HeadingType } from 'enums'
import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from '../common/button'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'

enum TextAlignment {
  Left = 'left',
  Right = 'right',
  Center = 'center'
}

interface Props {
  backgroundColor: string
  headingText: string
  headingTextColor: string
  textAlignment: TextAlignment
  buttonOne: LinkButtonProp
  buttonTwo: LinkButtonProp
  buttonTwoEnabled: boolean
  headingType: HeadingType
  headingClass: HeadingClass
}

const CTAFour = ({
  backgroundColor,
  headingText,
  headingTextColor,
  buttonTwoEnabled,
  buttonOne,
  buttonTwo,
  textAlignment,
  headingType,
  headingClass
}: Props) => {
  const getSecondButton = () => {
    if (!buttonTwoEnabled) return null

    return (
      <div className="ml-3 inline-flex">
        {buttonTwo && (
          <LinkButton
            buttonColor={buttonTwo.buttonColor}
            buttonText={`${buttonTwo.buttonText} `}
            buttonTextColor={buttonTwo.buttonTextColor}
            loggedInButtonText={buttonTwo.loggedInButtonText}
            loggedInButtonUrl={buttonTwo.loggedInButtonUrl}
            buttonUrl={buttonTwo.buttonUrl}
            isLink={buttonTwo.isLink}
            hasIcon={false}
            icon=""
            onClick={() => {}}
            classList={`
              ${buttonTwo.outline ? 'border-2 border-primary hover:underline' : ''}
                inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-full text-base bg-indigo-100 hover:bg-indigo-200
              `}
          />
        )}
      </div>
    )
  }

  const getButtonAlignment = () => {
    let alignment = 'flex-start'
    switch (textAlignment) {
      case TextAlignment.Center: {
        alignment = 'center'
        break
      }
      case TextAlignment.Right: {
        alignment = 'flex-end'
        break
      }
      default: {
        alignment = 'flex-start'
        break
      }
    }
    return alignment
  }

  const buttonAlignment = getButtonAlignment()

  return (
    <div className="bg-white" style={{ backgroundColor: backgroundColor }}>
      <div className="mx-auto max-w-7xl py-4 px-4 sm:px-6 md:py-8 lg:px-8 lg:py-8" style={{ textAlign: textAlignment }}>
        {/* <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl" style={{ color: topicTextColor }}>
          <span className="block">{topicText}</span>
        </h2> */}
        <CustomHeading
          classList="font-bold tracking-tight"
          headingClass={headingClass}
          headingType={headingType}
          color={headingTextColor}
        >
          {headingText}
        </CustomHeading>
        <div className="mt-8 flex" style={{ justifyContent: buttonAlignment }}>
          <div className="inline-flex rounded-full shadow">
            {buttonOne && (
              <LinkButton
                buttonColor={buttonOne.buttonColor}
                buttonText={`${buttonOne.buttonText} `}
                buttonTextColor={buttonOne.buttonTextColor}
                loggedInButtonText={buttonOne.loggedInButtonText}
                loggedInButtonUrl={buttonOne.loggedInButtonUrl}
                buttonUrl={buttonOne.buttonUrl}
                isLink={buttonOne.isLink}
                hasIcon={false}
                icon=""
                onClick={() => {}}
                classList={`
                  ${buttonOne.outline ? 'border-2 border-primary hover:underline' : ''} 
                  inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700
                `}
              />
            )}
          </div>
          {getSecondButton()}
        </div>
      </div>
    </div>
  )
}

export default CTAFour

Builder.registerComponent(CTAFour, {
  name: 'CTAFour',
  inputs: [
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'right', 'center'],
      defaultValue: 'center'
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'lightblue'
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'Boost your productivity. Start using workflow today.'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      ...{
        ...LinkButtonRegisterProps,
        subFields: [...LinkButtonRegisterProps.subFields, { name: 'outline', type: 'boolean', defaultValue: false }]
      },
      name: 'buttonOne'
    },
    {
      name: 'buttonTwoEnabled',
      type: 'boolean',
      defaultValue: true
    },
    {
      ...{
        ...LinkButtonRegisterProps,
        subFields: [...LinkButtonRegisterProps.subFields, { name: 'outline', type: 'boolean', defaultValue: false }]
      },
      name: 'buttonTwo'
    }
  ]
})
